import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import * as Toast from '../../lib/Toast.js';
import { formatCurrency } from '../../lib/CurrencyHelpers.js';
import { useState } from 'react';
import Select from '../Select';
import TextArea from '../TextArea.jsx';
import { setPaymentHistory } from '../../lib/Queries';
import Toggle from '../Toggle.jsx';
import ManualEntryForm, {
    ManualEntryMethodOptions,
} from './ManualEntryForm.jsx';

const PaymentWithManualEntry = ({
    objectId,
    objectType,
    amount,
    onSave,
    totalPrice,
    totalPaid,
}) => {
    const { save, isSaving } = useBusinessPostApi(
        `/payments/manual/${objectType}/${objectId}`,
    );
    const [method, setMethod] = useState(
        Object.keys(ManualEntryMethodOptions)[0],
    );
    const [notes, setNotes] = useState('');
    const [isFullyPaid, setIsFullyPaid] = useState(false);

    const isInvoice = objectType === 'invoice';
    const isPayingLessThanPrice =
        !isInvoice &&
        parseFloat(amount) + (parseFloat(totalPaid) || 0) <
        parseFloat(totalPrice);

    function doSave() {
        save({
            method,
            amount,
            notes,
            markAsPaid: isFullyPaid,
        }).then(result => {
            Toast.success(
                `Successfully recorded ${formatCurrency(amount)} payment`,
            );
            setPaymentHistory(objectType, objectId, result);
            onSave();
        });
    }

    return (
        <div>
            <ManualEntryForm
                isFullyPaid={isFullyPaid}
                setIsFullyPaid={setIsFullyPaid}
                showMarkFullyPaid={isPayingLessThanPrice}
                method={method}
                setMethod={setMethod}
                notes={notes}
                setNotes={setNotes}
            />

            <button type="button" className="btn-save" onClick={doSave}>
                {isSaving ? 'Saving...' : 'Save'}
            </button>
        </div>
    );
};

export default PaymentWithManualEntry;
